// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2haST","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1ivnI"};